import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  inject,
  Input,
  OnInit,
  output,
  ViewChild,
} from '@angular/core';
import {FormControl} from '@angular/forms';

import Quill from 'quill';
import {QuillEditorComponent, QuillModules} from 'ngx-quill';
import ImageCompress from 'quill-image-compress';
import {ImageHandler, Options} from 'ngx-quill-upload';
import {ImageCompressorOptions} from 'quill-image-compress';
Quill.register('modules/imageCompress', ImageCompress);
Quill.register('modules/imageHandler', ImageHandler);

// this clears stock icons. custom icons are set in scss file
const icons = Quill.import('ui/icons');
icons['header']['1'] = '<img src="">';
icons['header']['2'] = '<img src="">';
icons['bold'] = '<img src="">';
icons['italic'] = '<img src="">';
icons['underline'] = '<img src="">';
icons['list'] = '<img src="">';
icons['link'] = '<img src="">';
icons['image'] = '<img src="">';
icons['clean'] = '<img src="">';

//This is being saved in case it gets added in later
// import ImageResize from 'quill-image-resize-module';
// Quill.register('modules/imageResize', ImageResize);
// import './image-container-blot';

export type QuillConfig = QuillModules & {
  imageHandler?: Options;
  imageCompress?: ImageCompressorOptions;
};

@Component({
  selector: 'oph-quill-editor',
  standalone: false,
  templateUrl: './oph-quill-editor.component.html',
  styleUrl: './oph-quill-editor.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class OphQuillEditorComponent implements OnInit {
  private cdr = inject(ChangeDetectorRef);
  @ViewChild('editor', {
    static: true,
  })
  editor: QuillEditorComponent | undefined;
  @Input() placeholder = 'Write something...';
  @Input({required: true}) quillConfig: QuillModules = {};
  @Input() quillStyles = {
    borderRight: '1px solid #E5E3DC',
    borderLeft: '1px solid #E5E3DC',
    borderBottom: '1px solid var(--border)',
    borderBottomLeftRadius: '8px',
    borderBottomRightRadius: '8px',
    fontFamily: 'Asap',
    fontSize: '16px',
    width: '100%',
    maxHeight: '90%',
  };
  @Input() inputFC: FormControl;
  @Input() bounds: HTMLElement | string = 'self';
  @Input() class: string = '';
  @Input() isReadOnly = false;
  @Input() content: string = null;
  onQuillClick = output<MouseEvent>();
  onQuillEditorChange = output<string>();
  onQuillEditorFocus = output<PointerEvent>();

  quill: QuillEditorComponent;
  quillEditor: Quill;

  ngOnInit() {
    if (this.content) {
      this.inputFC = this.inputFC ?? new FormControl(this.content);
    } else {
      this.inputFC = this.inputFC ?? new FormControl();
    }
    this.cdr.detectChanges();
  }

  get showToolbar() {
    return this.quillConfig?.toolbar !== false;
  }

  setDisabledState(isDisabled: boolean): void {
    if (this.inputFC) {
      isDisabled ? this.inputFC.disable() : this.inputFC.enable();
    }
    if (this.quillEditor) {
      this.quillEditor.enable(!isDisabled);
    }
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  onEditorChanged(event: any) {
    this.onQuillEditorChange.emit(event);
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  onEditorFocus(event: any) {
    this.onQuillEditorFocus.emit(event);
  }

  onEditorCreated(editorInstance: QuillEditorComponent) {
    this.quill = editorInstance;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    this.quillEditor = (editorInstance as any).editor;
  }

  onQuillClickFn(event: MouseEvent) {
    this.onQuillClick.emit(event);
  }
}
